import { MB_CONFIG } from "../config";

export default {
    PATIENTS: lastUpdate => {
        if (lastUpdate) {
            return axios.get(
                MB_CONFIG.API_URL + "/patients/refresh/" + lastUpdate
            );
        }
        return axios.get(MB_CONFIG.API_URL + "/patients/all");
    },

    PATIENT: id => {
        return axios.get(MB_CONFIG.API_URL + "/patients/" + id);
    },

    DELETE_PATIENT: id => {
        return axios.delete(MB_CONFIG.API_URL + "/patients/" + id);
    },

    SAVE: patient =>
        patient.id
            ? axios.put(MB_CONFIG.API_URL + "/patients/" + patient.id, patient)
            : axios.post(MB_CONFIG.API_URL + "/patients", patient)
};
